import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table";
import { useLocation } from "react-router";
import GetAppIcon from "@material-ui/icons/GetApp";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {
  createStyles,
  Grid,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import {
  HeaderCellSort,
  useSort,
} from "@table-library/react-table-library/sort";
import "jspdf-autotable";
import { Icon } from "@iconify/react";

import { CustomTheme } from "../../../../types/customTheme";
import CardCommon from "../../../../components/card/CardCommon";
import MenuButtonCommon from "../../../../components/buttons/MenuButtonCommon";
import { handleDownloadCsv } from "./convertPdfExcel/convertDataToExcel";
import { handleDownloadPdf } from "./convertPdfExcel/convertDataToPdf";
import {
  sortDatesTime,
  sortNumbers,
  sortStrings,
} from "../../../../utils/commonArrayMap";
import LocationDetailsCard from "../../../../components/common/LocationDetailsCard";
import { getLocalStore } from "../../../../utils/store/localStore";
import { convertDateTimeFormat } from "../../../../utils/ConvertDateTimeFormat";

export interface PaymentReportInfoNodeProps {
  rewardRedeemedNodeList: any;
  locationSelectorList: any;
  filterDetails: any;
  filterData: any;
  basedOnShift: any;
  locationSelectedList: any;
  handleOnClickText: any;
  rewardNode: any;
}

const useStyles = (nodesLength: number, bodyLength: number) =>
  makeStyles((theme: CustomTheme) =>
    createStyles({
      startTextStyle: {
        fontWeight: "bold",
        display: "flex",
        justifyContent: "start",
        paddingLeft: "16px",
        fontSize: "12px",
      },
      textStyleHeader: {
        display: "flex",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "12px",
      },
      endTextStyle: {
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        fontSize: "12px",
        paddingRight: "20px",
      },
      headerEndTextStyle: {
        display: "flex",
        justifyContent: "end",
        fontWeight: "bold",
        fontSize: "12px",
        paddingRight: "16px",
      },
      textStyle: {
        display: "flex",
        justifyContent: "center",
        fontSize: "12px",
      },
      hiddenScroll: {
        // 1. For Webkit (Chrome, Safari, Edge)
        "&::-webkit-scrollbar": {
          height: "1px", // Set a smaller height for the horizontal scrollbar (e.g., 5px)
          backgroundColor: "transparent", // Make the track background transparent
        },

        // Style the actual draggable part (the thumb)
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0, 0, 0, 0.3)", // Subtle dark color for the thumb
          borderRadius: 1, // Make the thumb rounded
        },

        // 2. For Firefox
        scrollbarWidth: "thin", // Makes the scrollbar less intrusive
        // This defines the color of the thumb (first value) and the track (second value)
        scrollbarColor: `${theme.palette.background.entity_highlight_background_current_footer} transparent`,
      },

      headerStyle: {
        "&:last-of-type": {
          backgroundColor: theme.palette.background.table_header_background,
          color: theme.palette.custom.orange.contrastText,
        },
      },
      finalTotalRow: {
        cursor: "pointer",
        height: "40px",
        [`&:nth-of-type(${bodyLength + 1})`]: {
          color: theme.palette.custom["green"].contrastText,
          backgroundColor: theme.palette.custom.green.main,
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: theme.palette.custom.green.light,
          },
        },
      },
      totalRow: {
        cursor: "pointer",
        "&.css-16gtl2w": {
          display: "flex",
          justifyContent: "center",
        },
        "&:nth-of-type(n)": {
          color: theme.palette.custom["green"].contrastText,
          backgroundColor: theme.palette.custom.green.main,
          "&:hover": {
            backgroundColor: theme.palette.custom.green.light,
          },
        },
      },
      headerRow: {
        fontSize: "13px",
        cursor: "pointer",
        "&.css-16gtl2w": {
          display: "flex",
          justifyContent: "center",
        },
        "&:nth-of-type(odd)": {
          backgroundColor: theme.palette.background.paper,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
        "&:nth-of-type(even)": {
          backgroundColor: theme.palette.background.entity_background,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
      baseCellRow: {
        placeItems: "center",
        "& .css-16gtl2w": {
          fontWeight: "bold",
        },
        height: "40px",
        "&:nth-of-type(1)": {
          left: "0px",
          minWidth: `${100 / 9}%`,
          width: `${100 / 9}%`,
        },
        [theme.breakpoints.down("xl")]: {
          [`&:nth-of-type(n+2):nth-of-type(-n+${8})`]: {
            minWidth: `${100 / 9}%`,
            width: `${100 / 9}%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            },
          },
          [`&:nth-of-type(${9})`]: {
            minWidth: `${100 / 9}%`,
            width: `${100 / 9}%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "end",
              fontWeight: "bold",
              paddingRight: "16px",
            },
          },
        },
        [theme.breakpoints.down("lg")]: {
          [`&:nth-of-type(n+2):nth-of-type(-n+${8})`]: {
            minWidth: `20%`,
            width: `20%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            },
          },
          [`&:nth-of-type(${9})`]: {
            minWidth: `20%`,
            width: `20%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "end",
              fontWeight: "bold",
              paddingRight: "16px",
            },
          },
          "&:nth-of-type(1)": {
            left: "0px",
            minWidth: "20%",
            width: "20%",
          },
        },
        [theme.breakpoints.down("xs")]: {
          [`&:nth-of-type(n+2):nth-of-type(-n+${8})`]: {
            minWidth: "20%",
            width: "20%",
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            },
          },
          [`&:nth-of-type(${9})`]: {
            minWidth: "20%",
            width: "20%",
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "end",
              fontWeight: "bold",
              paddingRight: "16px",
            },
          },
          "&:nth-of-type(1)": {
            left: "0px",
            minWidth: "20%",
            width: "20%",
          },
        },
      },
    }),
  );

/**
 * PaymentReportInfoNode Component
 *
 * This component renders a table displaying payment report data.
 * It also provides options to export the report as PDF or CSV.
 * Users can view sale details by clicking on items in the table.
 */
const PaymentReportInfoNode: React.FunctionComponent<
  PaymentReportInfoNodeProps
> = ({
  rewardRedeemedNodeList,
  locationSelectorList,
  filterDetails,
  filterData,
  basedOnShift,
  locationSelectedList,
  handleOnClickText,
  rewardNode,
}) => {
  const [pdfHeaders, setPdfHeaders] = useState<any>([]);
  const [headersList, setHeadersList] = useState<any>([]);
  const [excelHeaders, setExcelHeaders] = useState<any>([]);
  const [nodes, setNodes] = useState<any>({ nodes: [] });
  const [nodesPdfExcel, setNodesPdfExcel] = useState<any>([]);
  const [footer, setFooter] = useState<any>([]);
  const [nodesLength, setNodeLength] = useState(0);
  const [bodyLength, setBodyLength] = useState(0);
  const [locationsLength, setLocationsLength] = useState(0);
  const [openSaleDetailsModal, setOpenSaleDetailsModal] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [cloneFilterData, setCloneFilterData] = useState("");

  const maxWidth = useMediaQuery("(max-width: 1500px)");
  const maxWidthCustom = useMediaQuery("(max-width: 1500px)");
  const open = Boolean(anchorEl);
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  useEffect(() => {
    setNodes({ nodes: [] });
  }, [params.get("startDate")]);
  function formatCostToSpendRatio(value: any) {
    if (!value || isNaN(value)) return "0%";
    const ratio = parseFloat(value) * 100;
    // Show 1 decimal if decimals exist, else no decimal
    const formatted = ratio % 1 === 0 ? ratio.toFixed(0) : ratio.toFixed(1);
    return `${formatted}%`;
  }

  /* Creating the data for the Payment report table and creating the data for pdf and excel files.
       Using a API request */
  useEffect(() => {
    let cloneRewardRedeemedNodeList: any = _.cloneDeep(rewardRedeemedNodeList);
    let footer: any = [];
    let totalSpendAmount = 0;
    let totalCostToSpendRatio = 0;

    if (Object.values(rewardNode).length > 0) {
      // ✅ Build the reward order list based on rewardNode keys (to preserve defined order)
      const rewardOrder = Object.keys(rewardNode);
      // ✅ Ensure all rewards exist in the clone list (even if 0 values)
      cloneRewardRedeemedNodeList.map((item: any) => {
        if (item.totalSpendAmount && item.rewardId) {
          totalSpendAmount = item.totalSpendAmount;
        }
      });
      rewardOrder.forEach((rewardId) => {
        const exists = cloneRewardRedeemedNodeList.some(
          (item: any) => item.rewardId === rewardId,
        );
        if (!exists) {
          cloneRewardRedeemedNodeList.push({
            rewardId: rewardId,
            avgCostPerReward: 0,
            totalRewardCost: 0,
            timesRedeemed: 0,
            totalSpendAmount,
            costToSpendRatio: 0,
            uniqueCustomers: 0,
            firstRedemption: "-",
            lastRedemption: "-",
          });
        }
      });

      // ✅ Sort by the order of rewardNode
      cloneRewardRedeemedNodeList.sort(
        (a: any, b: any) =>
          rewardOrder.indexOf(a.rewardId) - rewardOrder.indexOf(b.rewardId),
      );
      cloneRewardRedeemedNodeList = cloneRewardRedeemedNodeList
        // ✅ Keep only items that have a matching rewardId
        .filter((item: any) => item.rewardId && rewardNode[item.rewardId])
        // ✅ Then map and assign formatted data
        .map((item: any) => {
          totalCostToSpendRatio += item.costToSpendRatio || 0;
          return {
            ...item,
            rewardId: rewardNode[item.rewardId].title,
            costToSpendRatio: formatCostToSpendRatio(item.costToSpendRatio),
          };
        });
    }

    if (!_.isEmpty(cloneRewardRedeemedNodeList)) {
      footer = cloneRewardRedeemedNodeList.reduce(
        (acc: any, curr: any) => {
          acc.avgCostPerReward += curr.avgCostPerReward;
          acc.totalRewardCost += curr.totalRewardCost;
          acc.uniqueCustomers += curr.uniqueCustomers;
          acc.timesRedeemed += curr.timesRedeemed;
          return acc;
        },
        {
          rewardId: "Total",
          avgCostPerReward: 0,
          totalRewardCost: 0,
          costToSpendRatio: 0,
          timesRedeemed: 0,
          uniqueCustomers: 0,
          firstRedemption: "",
          lastRedemption: "",
        },
      );
      // ensure 2 decimals for totalRewardCost
      footer.totalRewardCost = parseFloat(footer.totalRewardCost).toFixed(2);
      footer.totalSpendAmount = totalSpendAmount
        ? parseFloat(parseFloat(totalSpendAmount.toString())?.toFixed(2))
        : 0;
      footer.costToSpendRatio = formatCostToSpendRatio(totalCostToSpendRatio);
      footer.avgCostPerReward = parseFloat(footer.avgCostPerReward.toFixed(2));

      // Set pdf headers
      setPdfHeaders([
        { title: "Reward Name", field: "rewardId" },

        { title: "Times Redeemed", field: "timesRedeemed" },
        { title: "Total Reward Cost", field: "totalRewardCost" },
        { title: "Avg Reward Cost", field: "avgCostPerReward" },
        { title: "Total Spend", field: "totalSpendAmount" },
        { title: "Cost To Spend Ratio", field: "costToSpendRatio" },
        { title: "Unique Customers", field: "uniqueCustomers" },
        { title: "First Redeemed", field: "firstRedemption" },
        { title: "Last Redeemed", field: "lastRedemption" },
      ]);

      // Set excel headers
      setExcelHeaders([
        {
          header: "Reward Name",
          key: "rewardId",
          width: 52,
          height: 68,
        },

        {
          header: "Times Redeemed",
          key: "timesRedeemed",
          width: 32,
          height: 68,
        },
        {
          header: "Total Reward Cost",
          key: "totalRewardCost",
          width: 32,
          height: 68,
        },
        {
          header: "Avg Reward Cost",
          key: "avgCostPerReward",
          width: 32,
          height: 68,
        },

        {
          header: "Total Spend",
          key: "totalSpendAmount",
          width: 32,
          height: 68,
        },
        {
          header: "Cost To Spend Ratio",
          key: "costToSpendRatio",
          width: 32,
          height: 68,
        },
        {
          header: "Unique Customers",
          key: "uniqueCustomers",
          width: 32,
          height: 68,
        },
        {
          header: "First Redeemed",
          key: "firstRedemption",
          width: 52,
          height: 68,
        },
        {
          header: "Last Redeemed",
          key: "lastRedemption",
          width: 32,
          height: 68,
        },
      ]);

      // Set table headers
      setHeadersList([
        "Reward Name",
        "Times Redeemed",
        "Total Reward Cost",
        "Avg Reward Cost",
        "Total Spend",
        "Cost To Spend Ratio",
        "Unique Customers",
        "First Redeemed",
        "Last Redeemed",
      ]);

      setNodeLength(cloneRewardRedeemedNodeList.length - 1);

      // Payment report length
      setBodyLength(cloneRewardRedeemedNodeList.length);

      // set the table data in the state
      setNodes({ nodes: cloneRewardRedeemedNodeList });

      // set the table footer in the state
      setFooter(footer);

      const merged = [...cloneRewardRedeemedNodeList, footer];

      // set the pdf excel data in the state
      setNodesPdfExcel(merged);
    }
  }, [rewardRedeemedNodeList, rewardNode]);

  // Create a pay In Out sorting function
  const sort = useSort(
    nodes,
    {},
    {
      sortFns: {
        "Reward Name": (array) => sortStrings(array, "rewardId"),
        "First Redeemed": (array) => sortDatesTime(array, "firstRedemption"),
        "Last Redeemed": (array) => sortDatesTime(array, "lastRedemption"),
        "Times Redeemed": (array) => sortNumbers(array, "timesRedeemed"),
        "Avg Reward Cost": (array) => sortNumbers(array, "avgCostPerReward"),
        "Total Reward Cost": (array) => sortNumbers(array, "totalRewardCost"),
        "Total Spend": (array) => sortNumbers(array, "totalSpendAmount"),
        "Cost To Spend Ratio": (array) =>
          sortNumbers(array, "costToSpendRatio"),
        "Unique Customers": (array) => sortNumbers(array, "uniqueCustomers"),
      },
      sortIcon: {
        margin: "0px",
        iconDefault: (
          <Icon
            icon="fluent:chevron-up-down-16-filled"
            width="44"
            height="44"
          />
        ),
        iconUp: <ArrowDropDownIcon />,
        iconDown: <ArrowDropUpIcon />,
      },
    },
  );

  const replaceLocationId = (inputString: any, newLocationId: any) => {
    // Regular expression to match and capture locationId values
    var regex = /locationId!\(([^)]+)\)/g;

    // Replace each match with the newLocationId
    var result = inputString.replace(
      regex,
      "locationId!(" + newLocationId + ")",
    );

    return result;
  };

  /* Open PDF / Excel selection menu */
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  /* Close PDF / Excel selection menu */
  const handleClose = () => {
    setAnchorEl(null);
  };

  /* Open the saleList modal */
  const handleOpenSaleListModal = (
    method: any,
    item: any,
    index?: any,
    isViewButtonClick?: any,
  ) => {
    // Setting the state of `openSaleDetailsModal` to `true`
    if ((index === 1 || isViewButtonClick) && method !== undefined) {
      setOpenSaleDetailsModal(true);
      setSelectedPaymentMethod(method);
      var result = replaceLocationId(filterData, item.locationId);
      setCloneFilterData(result);
    }
  };

  const handleOpenSaleListModalUsingFooter = (
    data: any,
    index: number,
    isViewButtonClick: boolean,
  ) => {
    if (
      data.Method !== "Total Payments" &&
      ((isViewButtonClick && data.Method !== "") ||
        (index === 1 && data.Method !== ""))
    ) {
      setOpenSaleDetailsModal(true);
      setSelectedPaymentMethod(data.Method);
      setCloneFilterData(filterData);
    }
  };

  const isDarkMode = getLocalStore("isDarkMode");
  const maxWidthLocationChips = useMediaQuery("(max-width: 600px)");
  const theme: CustomTheme = useTheme();
  const classes: any = useStyles(nodesLength, bodyLength)();

  return (
    <>
      <Grid
        container
        style={{
          marginBottom: "20px",
          marginTop: "8px",
        }}
      >
        <Grid item xs={12}>
          <div
            style={
              maxWidthLocationChips
                ? { display: "block" }
                : {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }
            }
          >
            <LocationDetailsCard
              locationSelectedList={locationSelectedList}
              handleOnClickText={handleOnClickText}
            />
            {!_.isEmpty(nodes.nodes) && (
              <div
                style={
                  maxWidthLocationChips
                    ? {
                        display: "flex",
                        justifyContent: "end",
                        marginTop: "8px",
                      }
                    : { marginLeft: "16px" }
                }
              >
                <MenuButtonCommon
                  id="basic-button"
                  variant="contained"
                  style={{
                    fontSize: 11,
                    height: "38px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                  }}
                  color="blue"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <GetAppIcon />
                  <Typography
                    variant="body1"
                    style={{ paddingLeft: "16px", color: "white" }}
                  >
                    Export
                  </Typography>
                </MenuButtonCommon>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  PaperProps={{
                    elevation: 0,
                    style: {
                      borderRadius: "10px",
                      border: `1px solid ${theme.palette.background.entity_border}`,
                    },
                  }}
                  style={{ top: "56px" }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      handleDownloadPdf(
                        "p",
                        pdfHeaders,
                        nodesPdfExcel,
                        filterDetails,
                        bodyLength,
                      );
                      handleClose();
                    }}
                  >
                    Export as PDF
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleDownloadCsv(
                        excelHeaders,
                        nodesPdfExcel,
                        filterDetails,
                        bodyLength,
                      );
                      handleClose();
                    }}
                  >
                    Export as CSV
                  </MenuItem>
                </Menu>
              </div>
            )}
          </div>
        </Grid>
      </Grid>

      <CardCommon>
        <Table
          data={nodes}
          sort={sort}
          layout={{ custom: maxWidthCustom, horizontalScroll: maxWidth }}
          className={classes.hiddenScroll}
        >
          {(tableList) => (
            <>
              <Header style={{ zIndex: 0 }}>
                <HeaderRow className={classes.headerStyle}>
                  {headersList.map(
                    (data: any, index: any) =>
                      data !== "rewardId" && (
                        <HeaderCellSort
                          sortKey={data}
                          pinLeft={index === 0 ? true : false}
                          className={classes.baseCellRow}
                          style={{ paddingRight: "4px" }}
                        >
                          <Typography
                            variant="caption"
                            className={
                              index === 0
                                ? classes.startTextStyle
                                : index === 6
                                ? classes.headerEndTextStyle
                                : classes.textStyleHeader
                            }
                            style={{
                              color: theme.palette.custom.orange.contrastText,
                            }}
                          >
                            {data}
                          </Typography>
                        </HeaderCellSort>
                      ),
                  )}
                </HeaderRow>
              </Header>

              <Body className={classes.bodyStyle}>
                {tableList.map((item, bodyIndex) => (
                  <>
                    <Row
                      key={item.gross20}
                      item={item}
                      className={
                        item.Method === "Total Payments"
                          ? classes.totalRow
                          : classes.headerRow
                      }
                    >
                      <Cell pinLeft={true} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.startTextStyle}
                        >
                          {item["rewardId"]}
                        </Typography>
                      </Cell>

                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.textStyle}
                        >
                          {item["timesRedeemed"]}
                        </Typography>
                      </Cell>
                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.textStyle}
                        >
                          {item["totalRewardCost"]}
                        </Typography>
                      </Cell>
                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.textStyle}
                        >
                          {item["avgCostPerReward"]}
                        </Typography>
                      </Cell>

                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.textStyle}
                        >
                          {item["totalSpendAmount"]}
                        </Typography>
                      </Cell>
                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.textStyle}
                        >
                          {item["costToSpendRatio"]}
                        </Typography>
                      </Cell>
                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.textStyle}
                        >
                          {item["uniqueCustomers"]}
                        </Typography>
                      </Cell>
                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.textStyle}
                        >
                          {item["firstRedemption"] &&
                          item["firstRedemption"] !== "-"
                            ? convertDateTimeFormat(item["firstRedemption"])
                            : "-"}
                        </Typography>
                      </Cell>
                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.endTextStyle}
                        >
                          {item["lastRedemption"] &&
                          item["lastRedemption"] !== "-"
                            ? convertDateTimeFormat(item["lastRedemption"])
                            : "-"}
                        </Typography>
                      </Cell>
                    </Row>
                    {bodyIndex + 1 === tableList.length && (
                      <>
                        <Row
                          className={classes.finalTotalRow}
                          key={footer.firstRedemption}
                          item={footer}
                        >
                          <Cell pinLeft={true} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.startTextStyle}
                            >
                              {footer["rewardId"]}
                            </Typography>
                          </Cell>

                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.textStyle}
                            >
                              {footer["timesRedeemed"]}
                            </Typography>
                          </Cell>
                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.textStyle}
                            >
                              {footer["totalRewardCost"]}
                            </Typography>
                          </Cell>
                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.textStyle}
                            >
                              {footer["avgCostPerReward"]}
                            </Typography>
                          </Cell>

                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.textStyle}
                            >
                              {footer["totalSpendAmount"]}
                            </Typography>
                          </Cell>
                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.textStyle}
                            >
                              {footer["costToSpendRatio"]}
                            </Typography>
                          </Cell>

                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.textStyle}
                            >
                              {footer["uniqueCustomers"]}
                            </Typography>
                          </Cell>
                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.textStyle}
                            >
                              {footer["firstRedemption"]}
                            </Typography>
                          </Cell>

                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.endTextStyle}
                            >
                              {footer["lastRedemption"]}
                            </Typography>
                          </Cell>
                        </Row>
                      </>
                    )}
                  </>
                ))}
              </Body>
            </>
          )}
        </Table>
      </CardCommon>
    </>
  );
};

export default PaymentReportInfoNode;
